<template>
  <div class="Dashboard">
    <div class="title">
      <h2 class="light">
        Dashboard
      </h2>
    </div>
    <SalesChart />
    <MySales />
    <div class="cards">
      <UpcomingDeadlines />
      <MyBookings />
      <BookingsSold v-if="false" />
    </div>
  </div>
</template>

<script>
import SalesChart from "@/components/SalesChart";
import UpcomingDeadlines from "@/components/UpcomingDeadlines";
import MyBookings from "@/components/MyBookings";
import BookingsSold from "@/components/BookingsSold";
import MySales from "@/components/MySales";

export default {
  name: "Dashboard",
  components: {
    MySales,
    SalesChart,
    UpcomingDeadlines,
    MyBookings,
    BookingsSold,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/responsive";
.Dashboard {
  .cards {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .panel {
      margin: 1em;
      padding: 1.142rem !important;

      @include phone {
        flex: 1;
      }
    }
  }
}
</style>
